/**
 * Session storage utilities for password reset flow
 *
 * State is persisted in sessionStorage so it survives page navigation
 * but is cleared when the browser tab closes.
 */

const RESET_PASSWORD_EMAIL = 'reset_password_email'
const RESET_PASSWORD_MASKED_EMAIL = 'reset_password_masked_email'
const RESET_PASSWORD_CUSTOMER_CODE = 'reset_password_customer_code'

export function getResetEmail() {
    if (typeof window === 'undefined') return null
    return sessionStorage.getItem(RESET_PASSWORD_EMAIL)
}

export function getMaskedEmail() {
    if (typeof window === 'undefined') return null
    return sessionStorage.getItem(RESET_PASSWORD_MASKED_EMAIL)
}

export function getCustomerCode() {
    if (typeof window === 'undefined') return null
    return sessionStorage.getItem(RESET_PASSWORD_CUSTOMER_CODE)
}

export function setResetEmail(email, maskedEmail) {
    if (typeof window === 'undefined') return
    sessionStorage.setItem(RESET_PASSWORD_EMAIL, email)
    if (maskedEmail) {
        sessionStorage.setItem(RESET_PASSWORD_MASKED_EMAIL, maskedEmail)
    }
}

export function setCustomerCode(code) {
    if (typeof window === 'undefined') return
    sessionStorage.setItem(RESET_PASSWORD_CUSTOMER_CODE, code)
}

export function clearResetState() {
    if (typeof window === 'undefined') return
    sessionStorage.removeItem(RESET_PASSWORD_EMAIL)
    sessionStorage.removeItem(RESET_PASSWORD_MASKED_EMAIL)
    sessionStorage.removeItem(RESET_PASSWORD_CUSTOMER_CODE)
}
